import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PermissionsTokenService {
  /*
    Decodifica el token JWT
    @param token - Token JWT
    @returns Objeto con el header y el payload del token
    */
  private decodeNoFormatJWT(token: string | null) {
    if (!token) {
      // No loguear error si no hay token (es normal durante el login)
      return null;
    }
    try {
      const [headerB64, payloadB64] = token.split('.');
      const header = JSON.parse(
        atob(headerB64.replace(/-/g, '+').replace(/_/g, '/'))
      );
      const payload = JSON.parse(
        atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/'))
      );
      return { header, payload };
    } catch (error) {
      console.error('Error decodificando token:', error);
      return null;
    }
  }

  /*
    Decodifica los permisos del token JWT
    @param token - Token JWT
    @returns Array de códigos de permisos o null
    */
  decodePermissions(token: string | null): string[] | null {
    const tokenNotFormmatted = this.decodeNoFormatJWT(token);
    if (
      tokenNotFormmatted &&
      tokenNotFormmatted.payload &&
      tokenNotFormmatted.payload.role_permits
    ) {
      const permissions = tokenNotFormmatted.payload.role_permits;

      // Si es un string JSON, parsearlo
      if (typeof permissions === 'string') {
        try {
          return JSON.parse(permissions);
        } catch (error) {
          console.error('Error parseando permisos:', error);
          return null;
        }
      }

      // Si ya es un array, retornarlo directamente
      if (Array.isArray(permissions)) {
        return permissions;
      }
    }
    return null;
  }

  /*
    Obtiene el payload completo del token
    @param token - Token JWT
    @returns Payload del token o null
    */
  getTokenPayload(token: string | null): any {
    const decoded = this.decodeNoFormatJWT(token);
    return decoded?.payload || null;
  }
}
